import React, { memo, useContext } from 'react';
import { Drawer } from 'antd';
import SideMenu from './SideMenu';
import UnAuthLayoutContext from '@/context/UnAuthLayoutContext';
import { ILayoutContext } from '@/context/LegacyLayoutContext';
import { MenuItem } from '@/types';

interface Props {
  menuItems: Array<MenuItem>;
  isCollapsed: boolean;
}

const SideMenuWrapper = memo<Props>((props) => {
  const layoutContext = useContext<ILayoutContext>(UnAuthLayoutContext);

  return layoutContext.isMobile ? (
    <Drawer
      placement="left"
      contentWrapperStyle={{
        width: '200px',
      }}
      style={{
        padding: 0,
        height: '100vh',
      }}
    >
      <SideMenu {...props} />
    </Drawer>
  ) : (
    <SideMenu {...props} />
  );
});

export default SideMenuWrapper;
